import axios from 'axios';

import { handleApiSucess, handleApiError, getRequestHeaders } from 'api/util.api';
import { handleRequest } from './util.api';

const getCustomFieldsEmployeesUrl = (cId, sId) =>
  `/companies/${cId}/subcompanies/${sId}/customfields`; // Corregido

const toggleCustomFieldEmployeeUrl = (eId, cId, sId) =>
  `/companies/${cId}/subcompanies/${sId}/customfields/${eId}/toggle`; // Falta

const addCustomFieldEmployeeUrl = (cId, sId) =>
  `/companies/${cId}/subcompanies/${sId}/customfields`; // Falta

const updateCustomFieldEmployeeUrl = (eId, cId, sId) =>
  `/companies/${cId}/subcompanies/${sId}/customfields/${eId}`; // Falta

const getCustomFieldEmployeeByIdUrl = (eId, cId, sId) =>
  `/companies/${cId}/subcompanies/${sId}/customfields/${eId}`; // Falta

const service = {
  configure(endpoint = '', auth = {}, defaultHeaders = {}) {
    this.endpoint = endpoint;
    this.auth = auth;
    this.defaultHeaders = defaultHeaders;
    this.getHeaders = getRequestHeaders(this.auth, this.defaultHeaders);

    this.axios = axios.create({
      baseURL: this.endpoint,
      timeout: 30000,
    });

    this.axios.interceptors.request.use((request) => {
      handleRequest(request);
      return request;
    });

    return this;
  },

  get(companyId, subcompanyId, filters, limit, page, orderBy, order) {
    // Corregido
    const url = getCustomFieldsEmployeesUrl(companyId, subcompanyId);
    const params = { ...filters, limit, page, orderBy, order };
    return this.axios
      .get(url, { ...this.getHeaders(), params })
      .then(handleApiSucess)
      .catch(handleApiError);
  },

  toggle(customFieldEmployeeId, companyId, subcompanyId) {
    // Corrigiendo
    const url = toggleCustomFieldEmployeeUrl(customFieldEmployeeId, companyId, subcompanyId);
    return this.axios
      .put(url, {}, { ...this.getHeaders() })
      .then(handleApiSucess)
      .catch(handleApiError);
  },

  getById(customFieldEmployeeId, companyId, subcompanyId) {
    // Falta
    const url = getCustomFieldEmployeeByIdUrl(customFieldEmployeeId, companyId, subcompanyId);
    return this.axios
      .get(url, { ...this.getHeaders() })
      .then(handleApiSucess)
      .catch(handleApiError);
  },

  update(customFieldEmployeeId, companyId, subcompanyId, custom_field_employee) {
    // Falta
    const url = updateCustomFieldEmployeeUrl(customFieldEmployeeId, companyId, subcompanyId);
    return this.axios
      .put(url, custom_field_employee, { ...this.getHeaders() })
      .then(handleApiSucess)
      .catch(handleApiError);
  },

  add(companyId, subcompanyId, custom_field_employee) {
    // Falta
    const url = addCustomFieldEmployeeUrl(companyId, subcompanyId);
    return this.axios
      .post(url, custom_field_employee, { ...this.getHeaders() })
      .then(handleApiSucess)
      .catch(handleApiError);
  },
};

export default service;



// WEBPACK FOOTER //
// src/lib/api/custom_fields_employees.api.js